export default __webpack_public_path__ + "static/media/BIFI-TOKEN.d0a6061e.svg";